import { PropsWithChildren, useState } from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { Hydrate } from "react-query/hydration";

interface Props {
  pageProps: any;
}
/**
 * A component that consolidates all the requirements to init ReactQuery in the _app component.
 */
function ReactQueryProvider({ pageProps, children }: PropsWithChildren<Props>) {
  const [queryClient] = useState(() => new QueryClient());

  return (
    <QueryClientProvider client={queryClient}>
      <Hydrate state={pageProps.dehydratedState}>{children}</Hydrate>
      <ReactQueryDevtools position="bottom-right" />
    </QueryClientProvider>
  );
}

export default ReactQueryProvider;
